import MainView from 'js/views/main';
import { initShareButtons } from 'js/utils/share-buttons';
import { initToc } from 'pmn/enhancements/toc';

export default class View extends MainView {
  mount(): void {
    super.mount();

    const startUserNovenaButton = document.querySelector<HTMLAnchorElement>(
      '[data-action="start-user-novena"]',
    );

    if (startUserNovenaButton) {
      this.trackLink(startUserNovenaButton, 'Clicked to start user novena');
    }

    initShareButtons();
    initToc();
    this.trackShareButtons('community-novena');
  }

  unmount(): void {
    super.unmount();
  }
}
